import React, { useState, useEffect } from 'react'
import ModeSearch from '../ModeSearch/ModeSearch'
import AdminManagementModule from './AdminManagementScreen.module.scss'
import { collection, doc, getDocs } from 'firebase/firestore'
import { db } from '../../firebase'

function AdminManagementScreenList({ systemItems, selectedItem, setSelectedItem, isEdited, setIsEdited }) {
  const [searchText, setSearchText] = useState('')
  const [filteredItems, setFilteredItems] = useState([])

  // アイテムのフィルタリング関数
  const filterItems = (items, query, key) => {
    return items.filter((item) => item[key].toLowerCase().includes(query.toLowerCase()))
  }

  // アイテムが変更された際のデータ取得・セット処理
  const fetchChildrenData = async (item) => {
    const itemDocRef = doc(db, `/systemSettings/${item.item_doc_id}`)
    const itemChildrenDataRef = collection(itemDocRef, 'itemChildrenData')
    const itemChildrenDataSnapshot = await getDocs(itemChildrenDataRef)
    return itemChildrenDataSnapshot.docs.map((childDoc) => ({
      ...childDoc.data(),
      ref: childDoc.ref
    }))
  }

  const switchBody = async (item) => {
    if (
      isEdited &&
      !window.confirm(
        '変更がまだ保存されていないようですが、よろしいですか？\n保存しないと、変更内容は消えてしまいます。'
      )
    ) {
      return
    }

    if (item.id === 'studentAnalysisPrompts' || item.id === 'submissionsAnalysisPrompt' || item.id === 'models') {
      setSelectedItem(item)
    } else if (!item) {
      setSelectedItem()
    } else {
      const itemChildrenData = await fetchChildrenData(item)
      setSelectedItem({ ...item, item_children_data: itemChildrenData })
      setIsEdited(false)
    }
  }

  // フィルタリングロジック
  useEffect(() => {
    const filtered = filterItems(systemItems, searchText, 'item_name')
    setFilteredItems(filtered)
  }, [searchText, systemItems])

  useEffect(() => {
    if (filteredItems[0]) {
      switchBody(filteredItems[0])
    }
  }, [filteredItems])

  return (
    <div className={AdminManagementModule.sidebar}>
      <div className={AdminManagementModule['sidebarheader-container']}>
        <div className={AdminManagementModule.sidebarheader}>
          <ModeSearch placeholderMessage="管理項目を検索..." searchText={searchText} setSearchText={setSearchText} />
        </div>
      </div>
      <div className={AdminManagementModule['list-container']}>
        <ul className={AdminManagementModule.list}>
          {filteredItems.map((item, index) => (
            <div key={index} className={AdminManagementModule.list}>
              <li
                key={index}
                className={`${AdminManagementModule.list} ${
                  selectedItem === item.id ? AdminManagementModule['selected-item'] : ''
                }`}
                onClick={() => switchBody(item)}
              >
                <p className={AdminManagementModule['list-title']}>{item.item_name}</p>
              </li>
            </div>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default AdminManagementScreenList
